// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__29ko7","label":"CategoryService_label__1oR3T","location":"CategoryService_location__1CApB"};